// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f94b7bee","513":"9b1c63e5","703":"0ec402d8"}[chunkId] + ".chunk.js";
};